import * as i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { Enum_Language } from "./contexts/language";
import frJSON from "./locales/fr.json";

i18n.use(initReactI18next).init({
    resources: {
        [Enum_Language.FR_FR]: {
            translation: frJSON,
        },
    },
    lng: Enum_Language.FR_FR,
});
